import { Chip } from '@material-ui/core';
import React from 'react';
import { ShoppingPaymentStatusId } from 'v2/interfaces/shopping';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';

type PaymentStatusTagProps = {
  delivery: ShoppingDelivery;
};

export function getInvoiceTagStyles(paymentStatusId: ShoppingPaymentStatusId) {
  let [color, border, backgroundColor] = ['#1e1e1e', '#d9d9d9 thin solid', '#fafafa'];

  if (paymentStatusId === ShoppingPaymentStatusId.ABERTA || paymentStatusId === ShoppingPaymentStatusId.AGUARDANDO_PAGAMENTO) {
    color = '#0958d9';
    border = '#e6f4ff thin solid';
    backgroundColor = '#91caff';
  }

  if (paymentStatusId === ShoppingPaymentStatusId.PAGA || paymentStatusId === ShoppingPaymentStatusId.NEGOCIADA) {
    color = '#389e0d';
    border = '#b7eb8f thin solid';
    backgroundColor = '#f6ffed';
  }

  if (paymentStatusId === ShoppingPaymentStatusId.AGUARDANDO_REEMBOLSO || paymentStatusId === ShoppingPaymentStatusId.REEMBOLSADO) {
    color = '#cf1322';
    border = '#ffa39e thin solid';
    backgroundColor = '#fff1f0';
  }

  if (paymentStatusId === ShoppingPaymentStatusId.EM_RECUPERACAO) {
    color = '#d4b106';
    border = '#d4b106 thin solid';
    backgroundColor = '#fffb8f';
  }

  return { color, border, backgroundColor };
}

function PaymentStatusTag({ delivery }: PaymentStatusTagProps) {
  return <Chip key={`status-tag-${delivery.invoiceId}`} size='small' label={delivery.statusName} style={getInvoiceTagStyles(delivery.status)} />;
}

export default PaymentStatusTag;
